import {
  TOPSPANDER_ALL_CABANG_GET_FAIL,
  TOPSPANDER_ALL_CABANG_GET_REQUEST,
  TOPSPANDER_ALL_CABANG_GET_RESET,
  TOPSPANDER_ALL_CABANG_GET_SUCCESS,
} from "../constants/TopSpanderAllCabangConstants";

export const topspanderModul_get_all_cabang_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case TOPSPANDER_ALL_CABANG_GET_REQUEST:
      return { loading: true };
    case TOPSPANDER_ALL_CABANG_GET_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case TOPSPANDER_ALL_CABANG_GET_FAIL:
      return { loading: false, error: action.payload };
    case TOPSPANDER_ALL_CABANG_GET_RESET:
      return {};
    default:
      return state;
  }
};
